import { AppConfig } from "@/config/app.config";
import {
    acceptLanguage,
    DecoratorRegistry,
    performanceLogging,
    provideApiVersion,
    provideRequestTimestamp,
    provideRetryAttempt,
    provideTracingAndIdempotency,
    registerConnector,
    serverTime,
} from "mfe-lib-bfo-shared/query";

export function registerPreLoginDecorators(i18n: any) {
    const preLogin = new DecoratorRegistry();

    preLogin.registerMany([
        performanceLogging(),
        serverTime(),
        acceptLanguage(i18n),
        provideRequestTimestamp(),
        provideTracingAndIdempotency(),
        provideRetryAttempt(),
        provideApiVersion(),
    ]);

    const apiBaseUrl = AppConfig.getBaseUrl();

    registerConnector({
        name: "preLogin",
        baseUrl: apiBaseUrl,
        registry: preLogin,
    });
}
